const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'https://moneyfalls.live/api'
).replace(/\/+$/, '');

async function post(path, body) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
  } catch (networkError) {
    return {
      status: 0,
      success: false,
      message:
        'Could not reach the Coinsflu server. Please check your internet connection and try again.',
    };
  }

  try {
    const payload = await response.json();
    return { status: response.status, ...payload };
  } catch (parseError) {
    return {
      status: response.status,
      success: false,
      message: 'Unexpected response from the server. Please try again.',
    };
  }
}

export const deleteAccountApi = {
  init: (coinsfluId, pin) =>
    post('/web/delete-account/init', { coinsflu_id: coinsfluId, pin }),
  confirm: (coinsfluId, pin, otp) =>
    post('/web/delete-account/confirm', { coinsflu_id: coinsfluId, pin, otp }),
};
